import React, { FC } from "react";

import StatusIcons from "./StatusIcons";

import OrderTab from "@/scenes/OrderManagement/enum/OrderTab";
import OrderDTO from "@/dto/order/OrderDTO";

interface StatusColumnProps {
    order?: OrderDTO;

    tab?: OrderTab;
}

// 订单状态图标列
const StatusColumn: FC<StatusColumnProps> = function (props) {
    // 异常订单需要显示状态icon
    const showOrderStatusIcon = props.tab === OrderTab.ABNORMAL;

    return (
        <td className="status-column">
            <StatusIcons order={props.order} showOrderStatusIcon={showOrderStatusIcon} />
        </td>
    );
};

export default StatusColumn;
